import { render, staticRenderFns } from "./TheAutomator.vue?vue&type=template&id=0fa63b92&scoped=true"
import script from "./TheAutomator.vue?vue&type=script&lang=js"
export * from "./TheAutomator.vue?vue&type=script&lang=js"
import style0 from "./TheAutomator.vue?vue&type=style&index=0&id=0fa63b92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa63b92",
  null
  
)

export default component.exports